













import {Component, Prop, Vue} from "vue-property-decorator";
import {MainPageConfig} from "@/interfaces/main-page.interface";
import Button from "@/components/Button.vue";

@Component({
  components: {
    Button
  }
})

export default class BackgroundText extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  @Prop() item: MainPageConfig.IImage;

}
